export const PROFILE_BEGIN = "PROFILE_BEGIN";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_FAIL = "PROFILE_FAIL";

export const PROFILE_UPDATE_BEGIN = "PROFILE_UPDATE_BEGIN";
export const PROFILE_UPDATE_SUCCESS = "PROFILE_UPDATE_SUCCESS";
export const PROFILE_UPDATE_FAIL = "PROFILE_UPDATE_FAIL";

// COMMENT

export const GET_COMMENT_BEGIN = "GET_COMMENT_BEGIN";
export const GET_COMMENT_SUCCESS = "GET_COMMENT_SUCCESS";
export const GET_COMMENT_FAIL = "GET_COMMENT_FAIL";

export const GET_DETAIL_COMMENT_BEGIN = "GET_DETAIL_COMMENT_BEGIN";
export const GET_DETAIL_COMMENT_SUCCESS = "GET_DETAIL_COMMENT_SUCCESS";
export const GET_DETAIL_COMMENT_FAIL = "GET_DETAIL_COMMENT_FAIL";

export const POST_COMMENT_BEGIN = "POST_COMMENT_BEGIN";
export const POST_COMMENT_SUCCESS = "POST_COMMENT_SUCCESS";
export const POST_COMMENT_FAIL = "POST_COMMENT_FAIL";

// CAMPAIGN

export const CREATE_CAMPAIGN_BEGIN = "CREATE_CAMPAIGN_BEGIN";
export const CREATE_CAMPAIGN_SUCCESS = "CREATE_CAMPAIGN_SUCCESS";
export const CREATE_CAMPAIGN_FAIL = "CREATE_CAMPAIGN_FAIL";

export const UPDATE_CAMPAIGN_BEGIN = "UPDATE_CAMPAIGN_BEGIN";
export const UPDATE_CAMPAIGN_SUCCESS = "UPDATE_CAMPAIGN_SUCCESS";
export const UPDATE_CAMPAIGN_FAIL = "UPDATE_CAMPAIGN_FAIL";

export const GET_RELATED_CAMPAIGN_BEGIN = "GET_RELATED_CAMPAIGN_BEGIN";
export const GET_RELATED_CAMPAIGN_SUCCESS = "GET_RELATED_CAMPAIGN_SUCCESS";
export const GET_RELATED_CAMPAIGN_FAIL = "GET_RELATED_CAMPAIGN_FAIL";

export const GET_DETAIL_CAMPAIGN_BEGIN = "GET_DETAIL_CAMPAIGN_BEGIN";
export const GET_DETAIL_CAMPAIGN_SUCCESS = "GET_DETAIL_CAMPAIGN_SUCCESS";
export const GET_DETAIL_CAMPAIGN_FAIL = "GET_DETAIL_CAMPAIGN_FAIL";

export const SHARE_CAMPAIGN_BEGIN = "SHARE_CAMPAIGN_BEGIN";
export const SHARE_CAMPAIGN_SUCCESS = "SHARE_CAMPAIGN_SUCCESS";
export const SHARE_CAMPAIGN_FAIL = "SHARE_CAMPAIGN_FAIL";

export const EDIT_CAMPAIGN_BEGIN = "EDIT_CAMPAIGN_BEGIN";
export const EDIT_CAMPAIGN_SUCCESS = "EDIT_CAMPAIGN_SUCCESS";
export const EDIT_CAMPAIGN_FAIL = "EDIT_CAMPAIGN_FAIL";

export const DELETE_CAMPAIGN_BEGIN = "DELETE_CAMPAIGN_BEGIN";
export const DELETE_CAMPAIGN_SUCCESS = "DELETE_CAMPAIGN_SUCCESS";
export const DELETE_CAMPAIGN_FAIL = "DELETE_CAMPAIGN_FAIL";